import { call } from '../core'

export interface IDataParams {
    data: any
}

export function sendData(params: IDataParams) {
    call('finSendData', params)
}
